import {useEffect, useState} from "react";
import associateServices from "../../../services";
import FormButton from "../../../components/form-button";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import QrCode from "../../../components/qr-code";
import CLIPBOARD_HELPER from "../../../helpers/clipboard-helpers";
import InformationToast from "../../../components/toast/InformationToast";

const INITIAL_INSTANCE = {
    password: '',
    newPassword: '',
    newPasswordConfirmation: '',
}

const TWO_FACTOR_INITIAL_INSTANCE = {
    password: '',
    code: '',
}
const SecuritySettings = () => {


    const {t} = useTranslation()
    const [isValid, setIsValid] = useState(false)
    const [otpStepPassword, setOtpStepPassword] = useState(false)
    const [isValidTwoFactor, setIsValidTwoFactor] = useState(false)
    const [loading, setLoading] = useState(false)
    const [authenticator, setAuthenticator] = useState({})


    const [instance, setInstance] = useState(INITIAL_INSTANCE)
    const [twoFactorInstance, setTwoFactorInstance] = useState(TWO_FACTOR_INITIAL_INSTANCE)

    useEffect(() => {
        if (document.querySelector('.form__group--pass1')) {
            const togglePassword1 = document.querySelector('#togglePass1');
            const password1 = document.querySelector('#pass1');

            togglePassword1?.addEventListener('click', function () {
                const type = password1.getAttribute("type") === "password" ? "text" : "password";
                password1.setAttribute("type", type);
                this.classList?.toggle('form__pass--active');
            });
        }

        if (document.querySelector('.form__group--pass2')) {
            const togglePassword2 = document.querySelector('#togglePass2');
            const password2 = document.querySelector('#pass2');

            togglePassword2?.addEventListener('click', function () {
                const type = password2.getAttribute("type") === "password" ? "text" : "password";
                password2.setAttribute("type", type);
                this.classList?.toggle('form__pass--active');
            });
        }

        if (document.querySelector('.form__group--pass3')) {
            const togglePassword3 = document.querySelector('#togglePass3');
            const password3 = document.querySelector('#pass3');

            togglePassword3?.addEventListener('click', function () {
                const type = password3.getAttribute("type") === "password" ? "text" : "password";
                password3.setAttribute("type", type);
                this.classList?.toggle('form__pass--active');
            });
        }
        if (document.querySelector('.form__group--pass1x')) {
            const togglePassword3 = document.querySelector('#togglePass1x');
            const password3 = document.querySelector('#pass1x');

            togglePassword3?.addEventListener('click', function () {
                const type = password3.getAttribute("type") === "password" ? "text" : "password";
                password3.setAttribute("type", type);
                this.classList?.toggle('form__pass--active');
            });
        }
        getAuthenticator()
        getOtpStep()

    }, [])


    const handleOtpLoginUpdate = () => {
        setLoadingOtpStep(true)
        associateServices.setOtpStep({
            password: otpStepPassword
        }).then(response => {

            if (response?.status !== 200) {
                setLoadingOtpStep(false)
                return toast(<InformationToast
                    icon={'ti-error-404'}
                    title={'...'}
                    message={t(`api-notifications.${response?.errors}`)}
                />)
            }

            getOtpStep()
        })
    }
    const getAuthenticator = () => {
        console.log('getAuthenticator = ')
        associateServices.getAuthenticatorLink().then(res => {
            console.log('ress = ', res)
            if (res?.errors === 'authenticator-enabled') {

                console.log('TEST ME')
                setAuthenticator({
                    enabled: true
                })
            } else
                setAuthenticator(res?.data || {})
        })
    }

    const [otpStep, setOtpStep] = useState(true)
    const [loadingOtpStep, setLoadingOtpStep] = useState(true)
    const getOtpStep = () => {
        setLoadingOtpStep(true)
        associateServices.getOtpStep().then(res => {
            setOtpStep(res?.data?.enabled)
            setLoadingOtpStep(false)
        })
    }

    useEffect(() => {
        setIsValid(instance.password && instance.newPassword && instance.newPasswordConfirmation)
    }, [instance])

    useEffect(() => {
        setIsValidTwoFactor(twoFactorInstance.password && twoFactorInstance.code)
    }, [twoFactorInstance])


    const handleSetAuthenticator = () => {
        setLoading(true)
        associateServices.setAuthenticator(twoFactorInstance).then(res => {
            setLoading(false)
            if (res?.status !== 200)
                return toast(<InformationToast
                    icon={'ti-x'}
                    title={t('general.information')}
                    message={t(`api-notifications.${res?.errors}`)}
                />)
            // return toast.error(t(`api-notifications.${res.errors}`))

            getAuthenticator()
            return toast(<InformationToast
                icon={'ti-check'}
                title={t('general.information')}
                message={t(`api-notifications.${res?.data}`)}
            />)
            // return toast.success(t(`api-notifications.${res.data}`))

        })
    }

    const handleChange = (type, value) => setInstance(prevState => ({
        ...prevState,
        [type]: value
    }))
    const handleChangeTwoFactor = (type, value) => setTwoFactorInstance(prevState => ({
        ...prevState,
        [type]: value
    }))

    const handleApiResponse = res => {
        setLoading(false)
        if (res?.status === 200) {
            setInstance(INITIAL_INSTANCE)
            return toast.success(t(`api-notifications.${res?.data}`))
        }

        return toast.error(t(`api-notifications.${res?.errors}`))
    }

    const handleChangePass = () => {
        if (instance.newPassword !== instance.newPasswordConfirmation)
            return toast.error(t('notifications.change-pass.passwords-mismatch'))


        setLoading(true)
        associateServices.changePass(instance).then(handleApiResponse)
    }

    const handleCopy = () => {
        CLIPBOARD_HELPER.copy(authenticator.secret || '')
        toast(<InformationToast
            title={t('settings.security.copied-secret-title')}
            message={t('settings.security.coped-secret-mesage')}
        />)
    }

    return (
        <div className="tab-pane fade show active">
            <div className="settings">
                <h3 className="settings__title">
                    {t('settings.security.password.title')}
                </h3>

                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12 col-xl-8 col-xxl-6">
                                    <div className="form__group form__group--pass1">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.security.password.old-password')} <b>*</b>
                                        </label>
                                        <input
                                            autoComplete="off"
                                            value={instance.password}
                                            onChange={e => handleChange('password', e.target.value)}
                                            type="password" className="form__input" id="pass1"/>
                                        <button className="form__pass" type="button" id="togglePass1"/>
                                    </div>


                                    <div className="form__group form__group--pass2">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.security.password.new-password')} <b>*</b>
                                        </label>
                                        <input
                                            autoComplete="off"
                                            value={instance.newPassword}
                                            onChange={e => handleChange('newPassword', e.target.value)}
                                            type="password" className="form__input" id="pass2"/>
                                        <button className="form__pass" type="button" id="togglePass2"/>
                                    </div>


                                    <div className="form__group form__group--pass3">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.security.password.new-password-confirm')} <b>*</b>
                                        </label>
                                        <input
                                            autoComplete="off"
                                            value={instance.newPasswordConfirmation}
                                            onChange={e => handleChange('newPasswordConfirmation', e.target.value)}
                                            type="password" className="form__input" id="pass3"/>
                                        <button className="form__pass" type="button" id="togglePass3"/>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="settings__actions">
                    <div className="settings__btns">
                        <FormButton
                            label={t('settings.security.password.update')}
                            disabled={!isValid}
                            loading={loading}
                            onClick={handleChangePass}

                        />
                    </div>
                </div>
            </div>

            <div className="settings">

                <h3 className="settings__title">
                    {t('settings.security.otp-step.title')}

                    <span className="settings__level">
                            <span className={otpStep ? 'green' : 'red'}>
                              {t(otpStep ? 'settings.security.otp-step.activated' : 'settings.security.otp-step.deactivated')}
                            </span>
                            </span>
                </h3>
                <p className="settings__text"> {t('settings.security.otp-step.description')}</p>


                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12 col-xl-8">

                                    <div className="form__group form__group--pass1x">
                                        <label htmlFor="" className="form__label">
                                            {t('register.password')}
                                            <b>*</b>
                                        </label>
                                        <input
                                            autoComplete={'current-password'}
                                            value={otpStepPassword}
                                            onChange={e => setOtpStepPassword(e.target.value)}
                                            type="password"
                                            className="form__input" id="pass1x"/>

                                        <button className="form__pass" type="button" id="togglePass1x"/>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="settings__actions">
                    <div className="settings__btns">
                        <FormButton
                            label={t(otpStep ? 'settings.security.otp-step.deactivate' : 'settings.security.otp-step.activate')}
                            disabled={!otpStepPassword || loadingOtpStep}
                            loading={loadingOtpStep}
                            onClick={handleOtpLoginUpdate}
                        />
                    </div>
                </div>
            </div>


            <div className="settings">

                <h3 className="settings__title">
                    {t('settings.security.two-factor.title')}

                    {
                        authenticator.enabled ?
                            <span className="settings__level">
                            <span className="green">
                              {t('general.enabled')}
                            </span>
                            </span>
                            : ''
                    }
                </h3>
                <p className="settings__text"> {t('settings.security.two-factor.description')}</p>


                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12 col-xl-8">
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.security.two-factor.code-description')} <b>*</b>
                                        </label>
                                        {
                                            authenticator?.secret &&
                                            <div className="form__wallet">
                                                <input
                                                    autoComplete={'off'}
                                                    value={authenticator?.secret || ''}
                                                    disabled={true}
                                                    type="text" className="form__input"/>

                                                <div className="form__actions">
                                                    <button onClick={handleCopy} type="button"
                                                            data-tooltip-id="copy-tooltip"
                                                            data-tooltip-content="Copy" data-tooltip-place="top">
                                                        <svg className="svg-icon">
                                                            <use
                                                                href="/static/media/sprite.a3c83f32de6c687e8a3b6e06a253b320.svg#copy"></use>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>


                                    {/**/}
                                </div>


                                {
                                    authenticator?.link &&
                                    <QrCode
                                        desc={''}
                                        size={64}
                                        small={true}
                                        centered={false}
                                        // value={'47FHQJA3PCZVLJDR4YHUIEE7K76XGELW'}
                                        value={authenticator?.link || ''}
                                    />
                                }


                                <div className="col-12 col-xl-8">

                                    <div className="form__group form__group--pass1x">
                                        <label htmlFor="" className="form__label">
                                            {t('register.password')}
                                            <b>*</b>
                                        </label>
                                        <input
                                            autoComplete={'current-password'}
                                            value={twoFactorInstance?.password}
                                            onChange={e => handleChangeTwoFactor('password', e.target.value)}
                                            type="password"
                                            className="form__input" id="pass1x"/>

                                        <button className="form__pass" type="button" id="togglePass1x"/>
                                    </div>

                                </div>

                                <div className="col-12 col-xl-8">
                                    <div className="form__group ">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.security.two-factor.two-factor-code')} <b>*</b>
                                        </label>
                                        <input
                                            value={twoFactorInstance.code}
                                            onChange={e => handleChangeTwoFactor('code', e.target.value)}
                                            type="text" className="form__input"/>
                                    </div>
                                    {/*otpauth://totp/MfaDemo:alan?algorithm=SHA1&digits=6&issuer=MfaDemo&period=30&secret=5CZ4UNFL54LOGJ24ZIWUHBY*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="settings__actions">
                    <div className="settings__btns">
                        <FormButton
                            label={t(authenticator.enabled ? 'settings.security.two-factor.deactivate' : 'settings.security.two-factor.activate')}
                            disabled={!isValidTwoFactor}
                            loading={loading}
                            onClick={handleSetAuthenticator}
                        />
                    </div>
                </div>
            </div>


        </div>


    )

}


export default SecuritySettings
